import { render } from "./ConfirmRegisterBiboEndorser.vue?vue&type=template&id=3304f377"
import script from "./ConfirmRegisterBiboEndorser.vue?vue&type=script&lang=ts"
export * from "./ConfirmRegisterBiboEndorser.vue?vue&type=script&lang=ts"
script.render = render

export default script